<div class="modal-header">
  <h4 class="modal-title pull-left">{{ title }}</h4>
  <button
    type="button"
    class="btn-close close pull-right"
    [attr.aria-label]="'ACCESSIBILITY.CLOSE' | translate"
    (click)="close()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-content></ng-content>
  <ng-template adHost></ng-template>

  <!-- <button type="button" class="btn btn-primary" (click)="openModal2(templateNested)">Open second modal</button>
    <button type="button" class="btn btn-primary" (click)="closeModal(1)">Close self</button>
    <button type="button" class="btn btn-primary" (click)="closeModal()">Close all modal</button> -->
</div>

<!--
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="close()">
    {{ closeLabel }}
  </button>
</div>
-->

<!-- TEST CON MODALE UI-KIT LASCAIRE COMMENTATO PER ORA -->
<!-- <ng-ui-kit-modal
  [visible]="true"
  [persistent]="true"
  [title]="title"
  (onClose)="close()"
  confirmDisable="true"
  [footer]="true"
  [closeOnCancel]="true">
  <ng-container header> Lorem ipsum dolor sit amet </ng-container>
  <ng-container body>
    <ng-content></ng-content>
    <ng-template adHost></ng-template>
  </ng-container>
  <ng-container footer>
    <button type="button" class="ic1-btn ic1-btn-sm ic1-btn-secondary">
      Annulla
    </button>
    <button type="button" class="ic1-btn ic1-btn-sm ic1-btn-primary">
      Conferma
    </button>
  </ng-container>
</ng-ui-kit-modal> -->
